import { Input, Select, Button, Row, Col, Space } from "antd";
import { SearchOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons";

const { Option } = Select;

export default function FileFilters({
  filters,
  setFilters,
  selectedCount,
  onDeleteSelected,
  disabled = false,
  availableUsers = [],
}) {
  const hasActiveFilters = filters.usuario || filters.nombre;

  const handleClearFilters = () => {
    setFilters({ usuario: "", nombre: "" });
  };

  return (
    <div style={{ width: "100%", marginBottom: 16 }}>
      {/* Row de filtros */}
      <Row gutter={[16, 16]} align="middle">
        {/* Buscar por nombre */}
        <Col xs={24} sm={12} md={8}>
          <label style={{ display: "block", fontWeight: 500, fontSize: 12 }}>
            Buscar por nombre
          </label>
          <Input
            placeholder="Buscar archivo..."
            value={filters.nombre}
            onChange={(e) => setFilters({ nombre: e.target.value })}
            prefix={<SearchOutlined />}
            disabled={disabled}
          />
        </Col>

        {/* Filtrar por usuario */}
        <Col xs={24} sm={12} md={8}>
          <label style={{ display: "block", fontWeight: 500, fontSize: 12 }}>
            Filtrar por usuario
          </label>
          <Select
            value={filters.usuario || "all"}
            onChange={(value) => setFilters({ usuario: value === "all" ? "" : value })}
            disabled={disabled}
            style={{ width: "100%" }}
            placeholder="Seleccionar usuario..."
          >
            <Option value="all">Todos los usuarios</Option>
            {availableUsers.map((user) => (
              <Option key={user} value={user}>
                {user}
              </Option>
            ))}
          </Select>
        </Col>

        {/* Botones de acción */}
        <Col xs={24} sm={24} md={8}>
          <Space>
            {hasActiveFilters && (
              <Button 
                style={{ marginTop: 18 }}
                onClick={handleClearFilters}
                disabled={disabled}
                icon={<CloseOutlined />}
              >
                Limpiar filtros
              </Button>
            )}
            {selectedCount > 0 && (
              <Button
                style={{ marginTop: 18 }}
                onClick={onDeleteSelected}
                disabled={disabled}
                danger
                icon={<DeleteOutlined />}
              >
                Eliminar seleccionados ({selectedCount})
              </Button>
            )}
          </Space>
        </Col>
      </Row>
    </div>
  );
}
